var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doneLoading)?_c('section',{staticClass:"tree-wrapper col"},_vm._l((_vm.nodes),function(node){return _c('q-au-model-tree-item-light',{key:node.key,attrs:{"node":node,"depth":0}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }